import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	belowFreeUserLimitTitle: {
		id: 'lock-screen-experiment.common.below-free-user-limit-title',
		defaultMessage: 'Your 14-day trial of the Standard plan has ended',
		description: 'Title for the lock screen informing user that the free trial has ended',
	},
	belowFreeUserLimitTitlePremium: {
		id: 'lock-screen-experiment.common.below-free-user-limit-title-premium',
		defaultMessage: 'Your Premium trial has ended',
		description: 'Title for the lock screen informing user that the free premium trial has ended',
	},
	adminBelowFreeUserLimitInstruction: {
		id: 'lock-screen-experiment.common.admin-below-free-user-limit-instruction',
		defaultMessage:
			"You've reached the end of your trial and not provided payment details. Add your payment details to stay on Standard, or switch to the Free plan.",
		description:
			'Body text for the lock screen showing possible next steps when number of user is below limit',
	},
	adminAboveFreeUserLimitInstruction: {
		id: 'lock-screen-experiment.common.admin-above-free-user-limit-instruction',
		defaultMessage:
			"You've reached the end of your trial and not provided payment details. To avoid losing your current data and setup, add your payment details to stay on Standard.{br}" +
			'Or <link>learn how to switch to Free.</link>',
		description:
			'Body text for the lock screen showing possible next steps when number of user is above limit',
	},
	adminBelowFreeUserLimitInstructionPremium: {
		id: 'lock-screen-experiment.common.admin-below-free-user-limit-instruction-premium',
		defaultMessage:
			'Add payment details to stay on Premium or <link>learn how to switch to Free</link>. If no action is taken, your account will be downgraded automatically.',
		description:
			'Body text for the lock screen showing possible next steps when number of user is below limit',
	},
	adminAboveFreeUserLimitInstructionPremium: {
		id: 'lock-screen-experiment.common.admin-above-free-user-limit-instruction-premium',
		defaultMessage:
			'Add payment details to stay on Premium or <link>learn how to switch to Free</link>. If no action is taken, your account will be deactivated.',
		description:
			'Body text for the lock screen showing possible next steps when number of user is above limit',
	},
	billingAdminBenefitTitlePremium: {
		id: 'lock-screen-experiment.common.billing-admin-benefit-title-premium',
		defaultMessage: 'Add payment details to stay on Premium and keep:',
		description: 'Title for the benefit section for billing admin',
	},
	nonBillingAdminBenefitTitlePremium: {
		id: 'lock-screen-experiment.common.non-billing-admin-benefit-title-premium',
		defaultMessage: 'Stay on Premium and keep:',
		description: 'Title for the benefit section for non-billing admin',
	},
	billingAdminBenefitTitle: {
		id: 'lock-screen-experiment.common.billing-admin-benefit-title',
		defaultMessage: 'Add payment details to stay on Standard and keep:',
		description: 'Title for the benefit section for billing admin',
	},
	nonBillingAdminBenefitTitle: {
		id: 'lock-screen-experiment.common.non-billing-admin-benefit-title',
		defaultMessage: 'Stay on Standard and keep:',
		description: 'Title for the benefit section for non-billing admin',
	},
	contactBillingAdmin: {
		id: 'lock-screen-experiment.common.contact-billing-admin',
		defaultMessage: 'Contact your billing admin to request the full Standard plan for your team.',
		description:
			'Footer text instructing user to contact billing admin if they want to keep standard plan',
	},
	contactBillingAdminPremium: {
		id: 'lock-screen-experiment.common.contact-billing-admin-premium',
		defaultMessage: 'Contact your billing admin to request the full Premium plan for your team.',
		description:
			'Footer text instructing user to contact billing admin if they want to keep premium plan',
	},
	aboveFreeUserLimitTitleJsm: {
		id: 'lock-screen-experiment.common.above-free-user-limit-title-jsm',
		defaultMessage:
			'Jira Service Management will be deactivated in {predunningDaysLeft} {predunningDaysLeft, plural, one {day} other {days}}',
		description:
			'Title for the lock screen in JSM showing that the free trial has ended and the instance will be deactivated',
	},
	aboveFreeUserLimitTitleJpd: {
		id: 'lock-screen-experiment.common.above-free-user-limit-title-jpd',
		defaultMessage:
			'Jira Product Discovery will be deactivated in {predunningDaysLeft} {predunningDaysLeft, plural, one {day} other {days}}',
		description:
			'Title for the lock screen in JPD showing that the free trial has ended and the instance will be deactivated',
	},
	aboveFreeUserLimitTitleJswSpork: {
		id: 'lock-screen-experiment.common.above-free-user-limit-title-jsw-spork',
		defaultMessage:
			'Jira will be deactivated in {predunningDaysLeft} {predunningDaysLeft, plural, one {day} other {days}}',
		description:
			'Title for the lock screen in JSW showing that the free trial has ended and the instance will be deactivated',
	},
	accessAllAgents: {
		id: 'lock-screen-experiment.common.access-all-agents',
		defaultMessage: 'Access for all of your agents',
		description: 'Text to show one of the benefit of keeping standard is access for all agents',
	},
	accessAllCreators: {
		id: 'lock-screen-experiment.common.access-all-creators',
		defaultMessage: 'Access for all of your creators',
		description: 'Text to show one of the benefit of keeping standard is access for all creators',
	},
	accessAllUsers: {
		id: 'lock-screen-experiment.common.access-all-users',
		defaultMessage: 'Access for all of your users',
		description: 'Text to show one of the benefit of keeping standard is access for all users',
	},
	businessHourSupport: {
		id: 'lock-screen-experiment.common.business-hour-support',
		defaultMessage: 'Business hour support',
		description:
			'Text to show one of the benefit of keeping standard is support during business hours',
	},
	dataResidency: {
		id: 'lock-screen-experiment.common.data-residency',
		defaultMessage: 'Data residency',
		description: 'Text to show one of the benefit of keeping standard is data residency',
	},
	unlimitedEmailNotification: {
		id: 'lock-screen-experiment.common.unlimited-email-notification',
		defaultMessage: 'Unlimited email notifications',
		description:
			'Text to show one of the benefit of keeping standard is unlimited email notifications',
	},
	learnMoreUrlText: {
		id: 'lock-screen-experiment.common.learn-more-url-text',
		defaultMessage: 'Learn more about the benefits of the Standard plan',
		description: 'Text for Url link to read more about benefits of the standard plan',
	},
	userRolesAndPermissions: {
		id: 'lock-screen-experiment.common.user-roles-and-permissions',
		defaultMessage: 'User roles and permissions',
		description:
			'Text to show one of the benefit of keeping standard is the ability to update user roles and permissions',
	},
	aboveFreeUserLimitTitleJswPremium: {
		id: 'lock-screen-experiment.common.above-free-user-limit-title-jsw-premium',
		defaultMessage: 'Action required: Your trial has ended',
		description:
			'Title for the lock screen in JSW showing that the premium free trial has ended and the instance will be deactivated',
	},
	crossTeamTimelines: {
		id: 'lock-screen-experiment.common.cross-team-timelines',
		defaultMessage: 'Cross-team timelines',
		description: 'Text to show one of the benefit of keeping premium is cross team timelines',
	},
	releaseTracks: {
		id: 'lock-screen-experiment.common.release-tracks',
		defaultMessage: 'Sandbox and release tracks',
		description: 'Text to show one of the benefit of keeping premium is being in release tracks',
	},
	atlassianIntelligence: {
		id: 'lock-screen-experiment.common.atlassian-intelligence',
		defaultMessage: 'Atlassian Intelligence (AI)',
		description: 'Text to show one of the benefit of keeping premium is Atlassian Intelligence',
	},
	premiumLearnMoreUrlText: {
		id: 'lock-screen-experiment.common.premium-learn-more-url-text',
		defaultMessage: 'See more Premium features',
		description: 'Text for Url link to read more about benefits of the premium plan',
	},
});
